import DashboardLayout from 'components/DashboardLayout';
import MenuItem from 'components/MenuItem';
import NotificationsBloc from 'components/NotificationsBloc';
import { FIND_CHARGE_URL } from 'constants/globalConstants';
import Faq from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions';
import { StyledShortBody } from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions/styles';
import LastSinistre from 'containers/AUTODashboard/Body/LastSinister';
import MyContracts from 'containers/AUTODashboard/Body/MyContracts';
import ServicesBloc from 'containers/AUTODashboard/Body/ServicesBloc';
import WelcomeHeader from 'containers/AUTODashboard/Header/WelcomeHeader';
import messages from 'containers/AUTODashboard/messages';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { translate } from 'helpers/intl';
import HeaderImage from 'images/header-img.png';
import { sanlamDarkBlue } from 'Material-UI/colors';
import React, { useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PAGES from 'routes/pages';
import { getContractsAuto } from 'store/contract/actions';
import { getContractAutoSelector } from 'store/contract/selectors';
import {
  getFaq,
  getLastNotification,
  openModalServicesAuto,
  setAutoDetailsPageBreadcrumbsPath,
  setNotificationRead,
} from 'store/global/actions';
import {
  getAutoFaqSelector,
  lastNotificationSelector,
} from 'store/global/selectors';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { getSinistres } from 'store/sinistre/actions';
import { getLastSinistre } from 'store/sinistre/selectors';
import { getFirstNameSelector } from 'store/user/selectors';
import { PRIVILEGES } from 'utils/globalConst';

const AUTODashbord = ({
  lastSinistre,
  contractsAuto,
  getLastNotification,
  lastNotification,
  firstName,
  setNotificationRead,
  getContractsAuto,
  getSinistres,
  setAutoDetailsPageBreadcrumbsPath,
  openModalServicesAuto,
  getFaq,
  faqAuto,
  ...otherProps
}: {
  intl: IntlShape;
  firstName: string;
  lastNotification: any;
  getLastNotification: Function;
  setNotificationRead: Function;
  getContractsAuto: Function;
  getSinistres: Function;
  setAutoDetailsPageBreadcrumbsPath: Function;
  openModalServicesAuto: Function;
  contractsAuto: [];
  lastSinistre: [];
  getFaq: Function;
  faqAuto: { question: string; id: number; code: string }[];
}) => {
  const language = useSelector(getLocaleSelector);
  const { AUTO } = PRIVILEGES;

  useEffect(() => {
    getLastNotification(AUTO);
  }, [AUTO, getLastNotification]);
  useEffect(() => {
    getContractsAuto();
  }, [getContractsAuto]);
  useEffect(() => {
    getSinistres();
  }, [getSinistres]);
  useEffect(() => {
    getFaq(language);
    // eslint-disable-next-line
  }, [language]);

  return (
    <GaLoadHOC
      category={EVENT_CATEGORIES.AUTO_ACCEUIL}
      label="Header Auto_BOUTON  Auto"
    >
      <DashboardLayout
        Faq={
          <Faq
            items={
              faqAuto &&
              faqAuto.map(
                (
                  item: { question: string; id: number; code: string },
                  index: number,
                ) => ({
                  title: (
                    <StyledShortBody
                      weight="bold"
                      color={sanlamDarkBlue}
                      key={index}
                    >
                      {item.question}
                    </StyledShortBody>
                  ),
                  id: item.id,
                  code: item.code,
                  path: '/faq',
                  isFaq: true,
                  category: EVENT_CATEGORIES.AUTO_ACCEUIL,
                  label: 'FAQ_' + ++index,
                }),
              )
            }
            GACategoryAllResponses={EVENT_CATEGORIES.AUTO_ACCEUIL}
          />
        }
        MyContracts={
          <MyContracts
            contractsAuto={contractsAuto}
            setDetailsPageBreadcrumbsPath={setAutoDetailsPageBreadcrumbsPath}
          />
        }
        LastSinistre={
          <LastSinistre
            lastSinistre={lastSinistre}
            setDetailsPageBreadcrumbsPath={setAutoDetailsPageBreadcrumbsPath}
          />
        }
        ServicesBloc={<ServicesBloc mdGrid={4} smGrid={4} />}
        WelcomeHeader={<WelcomeHeader name={firstName} />}
        HeaderImage={HeaderImage}
        MenuItem={
          <MenuItem
            setDetailsPageBreadcrumbsPath={setAutoDetailsPageBreadcrumbsPath}
            openServices={openModalServicesAuto}
            items={[
              {
                title: translate(
                  { ...messages.title_suivre_sinistre },
                  otherProps,
                ),
                icon: 'TimeLineIcon',
                path: PAGES.AUTO_DETAILS,
                BreadcrumbsPath: [
                  { name: 'auto', route: PAGES.AUTODASHBOARD },
                  { name: 'suiviDeSinistre' },
                ],
                openModalServices: false,
                category: EVENT_CATEGORIES.AUTO_ACCEUIL,
                label: 'AG_Suivre mes sinistres',
              },
              {
                title: translate(
                  { ...messages.title_contracts_garanties },
                  otherProps,
                ),
                icon: 'ContractGarantie',
                path: PAGES.AUTO_DETAILS,
                BreadcrumbsPath: [
                  { name: 'auto', route: PAGES.AUTODASHBOARD },
                  { name: 'contractEtGarantie' },
                ],
                openModalServices: false,
                category: EVENT_CATEGORIES.AUTO_ACCEUIL,
                label: 'AG_Contrats et garanties',
              },
              {
                title: translate({ ...messages.findCharge }, otherProps),
                icon: 'FindChargeIcon',
                isNew: true,
                onPress: () => {
                  window.open(FIND_CHARGE_URL, '_blank');
                },
                path: '',
                smalIcon: true,
                category: EVENT_CATEGORIES.AUTO_ACCEUIL,
                label: 'FindCharge Trouver une borne de recharge',
              },
            ]}
          />
        }
        NotificationsBloc={
          <NotificationsBloc
            message={lastNotification?.AUTO && lastNotification.AUTO.message}
            ignoreNotify={() =>
              setNotificationRead({
                id: lastNotification.AUTO.id,
                section: AUTO,
                isRedirectTo: false,
              })
            }
            clickEvent={() =>
              setNotificationRead({
                id: lastNotification.AUTO.id,
                section: AUTO,
              })
            }
          />
        }
      />
    </GaLoadHOC>
  );
};

const mapDispatchToProps = {
  getLastNotification,
  setNotificationRead,
  getContractsAuto,
  getSinistres,
  setAutoDetailsPageBreadcrumbsPath,
  openModalServicesAuto,
  getFaq,
};

const mapStateToProps = createStructuredSelector<
  any,
  {
    firstName: string;
    lastNotification: any;
    contractsAuto: any;
    lastSinistre: any;
    faqAuto: [];
  }
>({
  firstName: getFirstNameSelector,
  lastNotification: lastNotificationSelector,
  contractsAuto: getContractAutoSelector,
  lastSinistre: getLastSinistre,
  faqAuto: getAutoFaqSelector,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AUTODashbord));
export { AUTODashbord };
